import { Button } from '@/components/button';
import { Heading } from '@/components/heading';
import { ShipmentHistoryItem } from '@/components/modules/shipment/history/item';
import { useTruncated } from '@/hooks/use-truncated';
import { FULL_DATETIME_FORMAT } from '@/lib/constants';
import { ShipmentChangeModel, ShipmentModel } from '@/lib/models/shipment/types';
import { formatDateForUser } from '@/utils/format';
import { tv } from '@/utils/styles';

export interface ShipmentHistoryProps {
  historyEvent: ShipmentChangeModel;
}

const MAX_VISIBLE = 3;

const ShipmentHistory = ({ historyEvent }: ShipmentHistoryProps) => {
  const { createdAt, original, updated } = historyEvent;
  const dateString = createdAt ? formatDateForUser(createdAt, FULL_DATETIME_FORMAT) : '';

  const allKeys = Object.keys(original) as Array<keyof ShipmentModel>;
  const { rows, remainingRows, shouldShowAllRows, showAllRows, shouldShowLoadMore } = useTruncated<keyof ShipmentModel>(
    allKeys,
    MAX_VISIBLE,
  );

  const { heading, list } = styles();

  return (
    <article>
      <header>
        <Heading variant="h5" as="h2" className={heading()}>
          {dateString}
        </Heading>
      </header>
      <ul className={list()}>
        {rows.map((key) => (
          <ShipmentHistoryItem key={key} itemKey={key} original={original} updated={updated} />
        ))}
        {shouldShowLoadMore ? (
          <Button onClick={showAllRows} variant="link" size="small">
            {shouldShowAllRows ? 'Hide' : `+ ${remainingRows} more...`}
          </Button>
        ) : null}
      </ul>
    </article>
  );
};

const styles = tv({
  slots: {
    heading: 'mb-1 text-text-secondary',
    item: 'text-sm',
    list: 'list-inside list-disc',
  },
});

export { ShipmentHistory };
